// extracted by mini-css-extract-plugin
module.exports = {"cards":"ManageUserEntitlements_cards__3sc4x","no-entitlements":"ManageUserEntitlements_no-entitlements__MF5EB","spinner":"ManageUserEntitlements_spinner__RD2Tb"};